<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">
                        <!-- {{ selection }} -->
                        <b-tabs class="gridtabs" v-model="tabindex">
                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-shield text-primary mr-1"></i>
                                        Verify
                                    </div>

                                </template>

                                <p class="mt-0">
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="secondary">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> Enter verification details
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>

                                    <b-row class="my-2">

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Issue Date" label-size="sm">
                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm"
                                                        ref="issued_at" v-model="issued_at" :opens="'right'"
                                                        :locale-data="locale_data" :ranges="locale_ranges"
                                                        :showDropdowns="true" :linkedCalendars="true"
                                                        :single-date-picker="false" :disabled="false">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="false" @click="issued_at = {
                                                                startDate: null,
                                                                endDate: null,
                                                            }
                                                                ">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>


                                    <b-row v-if="checkit_result">
                                        <b-col>
                                            <b-alert :show="true" variant="warning">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6">
                                                            {{ checkit_message }}
                                                        </span>
                                                    </b-col>
                                                </b-row>
                                            </b-alert>
                                        </b-col>
                                    </b-row>

                                </p>
                            </b-tab>
                            <b-tab :disabled="remt.amount == ''">
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-plus-circle text-orange mr-1"></i>
                                        REMT
                                    </div>

                                </template>

                                <p class="mt-0">
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="secondary">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> Do you want to commit this upload to the
                                                            database?
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>

                                    <b-row class="my-4 text-2x strong">
                                        <b-col cols="6" sm="6" md="4" xl="2">SUM of REMT: </b-col>
                                        <b-col><span class="text-primary">{{
                                            remt.amount }}</span></b-col>
                                    </b-row>
                                    <b-row class="my-4 text-2x strong">
                                        <b-col cols="6" sm="6" md="4" xl="2">Period: </b-col>
                                        <b-col><span class="text-primary">{{
                                            remt.period }}</span></b-col>
                                    </b-row>

                                    <b-row v-if="checkit_result">
                                        <b-col>
                                            <b-alert :show="true" variant="warning">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6">
                                                            {{ checkit_message }}
                                                        </span>
                                                    </b-col>
                                                </b-row>
                                            </b-alert>
                                        </b-col>
                                    </b-row>

                                </p>
                            </b-tab>

                        </b-tabs>

                    </b-card-body>
                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col class="text-left">
                                <b-button v-if="tabindex == 0" squared size="sm" variant="warning"
                                    @click="bankingslines_remt">
                                    <i class="fa fa-check"></i>
                                    Check It
                                </b-button>

                                <!-- <b-button v-if="tabindex == 1" class="ml-2" squared size="sm" variant="primary"
                                    @click="ihold_publish(true)"
                                    :disabled="!blac || published || parseFloat(item.count) == 0">
                                    <i class="fa fa-check"></i>
                                    Publish It
                                </b-button> -->
                            </b-col>


                            <b-col class="text-right" cols="auto">
                                <b-button squared size="sm" variant="secondary" @click="back()">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>

                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "BankingsREMT",
    async mounted() {
        await this.accessdenied();
    },
    data() {
        return {
            busy: false,
            // requirement: {
            //     blac: "Supplier B/L"
            // },
            tabindex: 0,
            debounce: 500,
            readonly: false,
            issued_at: {
                startDate: this.$moment().add(-1, "months").startOf("month").format("YYYY-MM-DD"),
                endDate: this.$moment().add(-1, "months").endOf("month").format("YYYY-MM-DD"),
            },
            blac: null,
            options_status: [
                { id: "ready", label: "Ready" },
                { id: "pending", label: "Pending" }
            ],
            status_from: 'pending',
            status_to: 'ready',
            blockedevent: true,
            blockedslac: true,
            published: false,
            publishit_message: "",
            publishit_result: false,
            checkit_message: "",
            checkit_result: false,
            sendannouncementemail: "true",
            message: "",
            id: null,
            remt: {
                amount: '',
                period: ''
            }
        };
    },
    watch: {
        async tabindex() {
            if (this.tabindex == 0) {
                this.remt = {
                    amount: '',
                    period: ''
                }
            }
        },
        async issued_at() {

        },

    },
    methods: {
        async accessdenied() {

        },
        async bankingslines_remt(ss) {

            let variables = {

            };
            this.remt = []
            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query bankingslines_remt {
                        bankingslines_remt {
                        amount
                        period
                        }
                    }
                    `,
                    variables,
                });

                this.remt = response.data.bankingslines_remt
                this.remt.amount = parseFloat(this.remt.amount).toLocaleString(undefined, { minimumFractionDigits: 2 })

            } catch (error) {

            }

            this.tabindex = 1

        },
        async back() {
            if (!this.router_loaded) {
                this.$emit('discard')
            } else {
                this.$router.back(-1)
            }

        },
    },
};
</script>